module.exports = __webpack_public_path__ + "static/media/detail_0037_f.64eafe39.jpg";